import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '@/store'
import convoStore from '../convo-store'
import setMeta from './set-meta'
import { IConvo, ConvoMeta } from '@/model/convo'

export default async function processConvos(context: BareActionContext<ConvoState, RootState>, convos: IConvo[])
{
  for(let i=0; i<convos.length; i++) {
    convos[i].meta = new ConvoMeta()
  }
  convoStore.commitSetConvos({ convos: convos })
  convoStore.commitSetIsLoading({isLoading: false})
  for(let i=0; i<convos.length; i++) {
    setMeta(context, convoStore.state.convos[i])
  }

  return
}
